// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2rl7S","groups":"styles_groups__3RXPz"};